import { EntryMethodDetails } from 'components/enter/EntryMethod';
import OrderSummarySection from 'components/enter/order-summary/OrderSummarySection';
import MainLayout from 'components/layout/MainLayout';
import { PaymentLayout } from 'components/layout/payment/PaymentLayout';
import { AdyenCheckoutWrapper } from 'components/payments/AdyenCheckoutWrapper';
import Subheading from 'components/Subheading';
import { useConfirmationData } from 'hooks/confirmation/useConfirmationData';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { useUIStore } from 'hooks/stores/useUIStore';
import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';
import { NextSeo } from 'next-seo';
import { useEffect } from 'react';
import { ASSET_PREFIX } from 'utils/constants';

const Payment = observer(() => {
  const { entryMethod, isUpgradeFlow, initialised, initialised_promocode } =
    useEnterStore();
  const { navigateToDashboard } = useUIStore();
  const { currentUser, activeSubscriptions } = useUserStore();
  const { loading: confirmationLoading } = useConfirmationData();

  useEffect(() => {
    if (
      confirmationLoading &&
      currentUser &&
      activeSubscriptions.length > 0 &&
      !isUpgradeFlow
    ) {
      navigateToDashboard();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  return (
    <MainLayout>
      <NextSeo
        title="Online Contest | Your Chance to Win Epic Prizes | DAYMADE"
        description="Enter our online contests for your chance to win unbelievable prizes! How does brunch in Bali sound? And what about luxury breaks? Play today for just £2.95."
        openGraph={{
          title: 'Online Contest | Your Chance to Win Epic Prizes | DAYMADE',
          description:
            'Enter our online contests for your chance to win unbelievable prizes! How does brunch in Bali sound? And what about luxury breaks? Play today for just £2.95.',
        }}
      />
      <div
        className={
          'w-full max-w-[1200px] flex justify-center p-4 my-2 md:my-4 gap-4 mb-10'
        }
      >
        <PaymentLayout
          PaymentComponent={
            initialised &&
            initialised_promocode && (
              <div className="w-full max-w-[450px] mb-6">
                <Subheading
                  underlineColor={
                    entryMethod
                      ? EntryMethodDetails[entryMethod].underlineGlowColor
                      : '#95F5DE'
                  }
                  id="youMightAlsoLikeSection"
                >
                  <div className="!normal-case">Payment</div>
                </Subheading>

                <div className="w-full flex justify-center">
                  <img src={`${ASSET_PREFIX}/static/trust_pilot.svg`} />
                </div>

                <div style={{ margin: '2em 0' }}>
                  <AdyenCheckoutWrapper />
                </div>
                <div className="flex justify-evenly w-full ">
                  <img
                    src={`${ASSET_PREFIX}/images/enter/payment-icons/secure-checkout.svg`}
                  />
                  <img
                    src={`${ASSET_PREFIX}/images/enter/payment-icons/privacy-protected.svg`}
                  />
                  <img
                    src={`${ASSET_PREFIX}/images/enter/payment-icons/trustpilot.svg`}
                  />
                </div>
              </div>
            )
          }
          OrderSumaryComponent={<OrderSummarySection />}
        />
      </div>
    </MainLayout>
  );
});

export default Payment;
